import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cdkFilterList'
})
export class CdkFilterListPipe implements PipeTransform {
  transform(list: any[], filterText: string): any {
    return !filterText
      ? list
      : list.filter(
        (item) =>
          item.subDepartmentName.toLowerCase().includes(filterText.toLowerCase())
      );
  }
}
